import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "navbar navbar-light bg-light" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "navbar-brand mb-0 h1" }, "Attention Viz", -1)
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "layernum",
  style: {"margin-left":"0"}
}, "Zoom to Layer", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "explore a single attention head by selecting a layer and head number", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "headnum" }, "Head", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" go ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" reset zoom ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" view all heads ")
const _hoisted_11 = { class: "dropdown" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" about ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Attention Viz"),
  /*#__PURE__*/_createTextVNode(" is an interactive tool that visualizes global attention patterns for transformer models. To create this tool, we visualize the joint embeddings of "),
  /*#__PURE__*/_createElementVNode("b", { class: "green" }, "query"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("b", { class: "pink" }, "key"),
  /*#__PURE__*/_createTextVNode(" vectors. Click a button below to learn more.")
], -1)
const _hoisted_14 = { class: "modal-buttons" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Documentation")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Paper")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Code")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Jump Right In")
const _hoisted_19 = { class: "main" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = {
  class: "col-2",
  id: "attn-div"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_Projection = _resolveComponent("Projection")!
  const _component_AttnMapWrapper = _resolveComponent("AttnMapWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_a_tooltip, { placement: "bottomRight" }, {
            title: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "info",
                class: "info-icon"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_select, {
            ref: "layer-select",
            value: _ctx.layernum,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.layernum) = $event)),
            style: {"width":"60px"},
            layerNum: _ctx.layernum,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChange('layer', _ctx.layernum)))
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                return _createVNode(_component_a_select_option, {
                  value: i - 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(i - 1), 1)
                  ]),
                  _: 2
                }, 1032, ["value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["value", "layerNum"]),
          _hoisted_7,
          _createVNode(_component_a_select, {
            ref: "head-select",
            value: _ctx.headnum,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.headnum) = $event)),
            style: {"width":"60px"},
            headNum: _ctx.headnum,
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleChange('head', _ctx.headnum)))
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                return _createVNode(_component_a_select_option, {
                  value: i - 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(i - 1), 1)
                  ]),
                  _: 2
                }, 1032, ["value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["value", "headNum"]),
          _createVNode(_component_a_button, {
            type: "primary",
            id: "zoom-go",
            onClick: _ctx.zoomToPlot
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "text",
            class: "matrix-reset",
            onClick: _ctx.onClickReset
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "text",
            class: _normalizeClass(["matrix-reset", {
          disabled: _ctx.mode == 'matrix'
        }]),
            onClick: _ctx.resetToMatrix
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick", "class"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_a_button, {
            type: "text",
            class: "matrix-reset",
            onClick: _ctx.showModal,
            style: {"margin-left":"0"}
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_modal, {
            visible: _ctx.modalVisible,
            "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalVisible) = $event)),
            width: "550px",
            title: "About Attention Viz",
            onOk: _ctx.closeModal
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  id: "docs-link",
                  href: "https://catherinesyeh.github.io/attn-docs/",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  type: "primary",
                  id: "paper-link",
                  target: "_blank",
                  href: "https://ieeexplore.ieee.org/document/10297591"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  type: "primary",
                  id: "code-link",
                  target: "_blank",
                  href: "https://github.com/catherinesyeh/attention-viz"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  type: "primary",
                  id: "close-link",
                  onClick: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["visible", "onOk"]),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.icon,
                onClick: _ctx.toggleTheme
              }, null, 8, ["icon", "onClick"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", {
          class: _normalizeClass({ 'col-10': _ctx.showAttn && _ctx.view == 'attn', 'col-12': !_ctx.showAttn || _ctx.view != 'attn' })
        }, [
          _createVNode(_component_Projection, { ref: "projection" }, null, 512)
        ], 2),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_21, [
              _createVNode(_component_AttnMapWrapper, { id: "attn-wrap" })
            ], 512), [
              [_vShow, _ctx.showAttn && _ctx.view == 'attn']
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}